import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import React, { forwardRef, useCallback } from 'react';
import { Avatar } from './Avatar.js';
import { AvatarGroupProvider } from './context/AvatarGroupProvider.js';
import defaultStyles from './styles/Avatar.module.scss.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { isNumber } from '../../utils/is.js';

const AvatarGroup = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    theme,
    children,
    size = 'sm',
    variant = 'circle',
    autoFixFontSize = true,
    maxCount,
    dataTestId,
    ...rest
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const childrenArr = React.Children.toArray(children);
  const renderAvatars = useCallback(() => {
    const avatarCount = childrenArr.length;
    let avatarsToRender = childrenArr;
    const avatarProps = {
      theme: {
        avatar: styles.max_count
      },
      size,
      variant,
      autoFixFontSize
    };
    if (isNumber(maxCount) && maxCount >= 0 && avatarCount > maxCount) {
      const avatarsInPopover = childrenArr.slice(maxCount);
      avatarsToRender = childrenArr.slice(0, maxCount);
      avatarsToRender.push( /*#__PURE__*/jsxs(Avatar, {
        ...avatarProps,
        children: ["+", avatarsInPopover.length]
      }, "avatar_group_popup"));
    }
    return avatarsToRender.map((item, index) => {
      if ( /*#__PURE__*/React.isValidElement(item)) {
        return /*#__PURE__*/jsx(Fragment, {
          children: /*#__PURE__*/React.cloneElement(item, {
            key: index,
            size,
            variant,
            autoFixFontSize
          })
        });
      }
      return null;
    });
  }, [autoFixFontSize, childrenArr, maxCount, size, styles.max_count, variant]);
  const groupProps = {
    className: styles.group,
    'data-test-id': dataTestId
  };
  return /*#__PURE__*/jsx(AvatarGroupProvider, {
    size: size,
    variant: variant,
    autoFixFontSize: autoFixFontSize,
    children: /*#__PURE__*/jsx("div", {
      ref: ref,
      ...rest,
      ...groupProps,
      children: renderAvatars()
    })
  });
});
AvatarGroup.displayName = 'AvatarGroup';

export { AvatarGroup };
